import i18n from "@/i18n";

export const tableConfigs = () => {
    return [
        {
            label: "",
            value: "date"
        },
        {
            label: i18n.t("zhiji.serviceData.pvLabel"),
            value: "pv"
        },
        {
            label: i18n.t("zhiji.serviceData.uvLabel"),
            value: "uv"
        },
        {
            label: i18n.t("zhiji.serviceData.createNum"),
            value: "tikCreateNum"
        },
        {
            label: i18n.t("zhiji.serviceData.createUser"),
            value: "tikCreateUser"
        },
        {
            label: i18n.t("zhiji.serviceData.handleNum"),
            value: "tikHandleNum"
        },
        {
            label: i18n.t("zhiji.serviceData.tikHandleUser"),
            value: "tikHandleUser"
        },
        {
            label: i18n.t("zhiji.serviceData.tikArtificialNum"),
            value: "tikArtificialNum"
        },
        {
            label: i18n.t("zhiji.serviceData.tikAutoNum"),
            value: "tikAutoNum"
        },
        {
            label: i18n.t("zhiji.serviceData.tikUrgentNum"),
            value: "tikUrgentNum"
        },
        {
            label: i18n.t("zhiji.serviceData.avgDealTime"),
            value: "avgDealTime"
        },
        {
            label: i18n.t("zhiji.serviceData.questionNum"),
            value: "questionNum"
        },
        {
            label: i18n.t("zhiji.serviceData.uv"),
            value: "robotUv"
        },
        {
            label: i18n.t("zhiji.serviceData.penalizeUser"),
            value: "penalizeUser"
        }
    ];
};
